"use strict";
import { useEffect } from "react";
let isInitialized = false;
let currentScrollY = 0;
export function initializeScrollWatcher() {
  if (isInitialized) {
    return;
  }
  window.addEventListener("scroll", () => currentScrollY = window.scrollY);
  isInitialized = true;
}
export function updateScrollLock({ isModalOpen }) {
  if (!isInitialized) {
    initializeScrollWatcher();
  }
  if (isModalOpen) {
    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${currentScrollY}px`;
  } else {
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
  }
}
export function useUpdateScrollLock({ isModalOpen }) {
  useEffect(() => {
    updateScrollLock({ isModalOpen });
    return () => updateScrollLock({ isModalOpen: false });
  }, [isModalOpen]);
}
